import { Dialog, DialogBoddy } from '@/components';
import { SendInviteSection } from './contact/SendInviteSection';

interface SendInviteDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSendInvite: (email: string) => void;
  isLoading?: boolean;
  defaultEmail?: string;
}

export function SendInviteDialog({
  isOpen,
  onClose,
  onSendInvite,
  isLoading = false,
  defaultEmail = '',
}: SendInviteDialogProps) {
  return (
    <Dialog isOpen={isOpen} onClose={onClose}>
      <DialogBoddy>
        <SendInviteSection
          onSendInvite={onSendInvite}
          onCancel={onClose}
          isLoading={isLoading}
          defaultEmail={defaultEmail}
        />
      </DialogBoddy>
    </Dialog>
  );
}
